import "./CardPrices.scss";

import priceMonthFree from "../../assets/images/price_month_free.svg";
import checkWhite from "../../assets/icons/CheckWhite.svg";
import crossWhite from "../../assets/icons/CrossWhite.svg";
function CardPrice({
  vector,
  plus,
  titleTabPrices,
  descriptionTabPricesTop,
  descriptionTabPricesTopSupEnd,
  descriptionTabPrices,
  descriptionTabPricesSup,
  descriptionTabPricesSupEnd,
  pricesTab,
  countryPrice,
  mostUsed,
  privilegeElection,
  handleClick,
  firstFree,
  posSymbol,
  preSymbol,
  vectorTop,
  vectorTopName,
  classCountry,
}) {
  return (
    <div
      className={
        firstFree
          ? `cardPrices cardPricesBorder ${classCountry} `
          : `cardPrices ${classCountry}`
      }
    >
      {firstFree && (
        <div className="divContainerMonthFree">
          <div className="divMonthFree">
            {/* <img src={priceMonthFree} alt="" /> */}
          </div>
        </div>
      )}

      <div className="productContainer">
        <div>
          <p className="titleTabPrices"> {titleTabPrices}</p>

          <div className={`priceTabBox priceTabBox--empty`}>
            {preSymbol && <p className="symbol">{preSymbol}</p>}
            <h2 className="pricesTab">{pricesTab}</h2>
            {posSymbol && <p className="symbol">{posSymbol}</p>}{" "}
            <p className="marginLeft">{countryPrice}</p>
          </div>
          <div>
            <p className="descriptionTabPricesNew">
              {descriptionTabPricesTop}
              {descriptionTabPricesTopSupEnd && (
                <sup>{descriptionTabPricesTopSupEnd}</sup>
              )}
            </p>
          </div>
          <a
            className={firstFree ? "buttonPayTab buttonBlue" : "buttonPayTab"}
            href={privilegeElection}
          >
            Seleccionar Plan
          </a>
          {vectorTop && (
            <div className="listItemTabPrices">
              <p>{vectorTopName}</p>
              {vectorTop === undefined
                ? ""
                : vectorTop.map((x, index) => (
                    <div className="listItemDetail" key={`vector-${index}`}>
                      <img
                        src={x.option === 1 ? checkWhite : crossWhite}
                        alt="vector"
                        className="imgService"
                      />
                      <p className={x.option === 0 && "disabled"}>{x.text}</p>
                    </div>
                  ))}
            </div>
          )}

          <div className="listItemTabPrices">
            <p>Incluye:</p>
            {vector === undefined
              ? ""
              : vector.map((x, index) => (
                  <div className="listItemDetail" key={`vector-${index}`}>
                    <img
                      src={x.option === 1 ? checkWhite : crossWhite}
                      alt="vector"
                      className="imgService"
                    />
                    <p className={x.option === 0 && "disabled"}>
                      {x.text} {x.sup && <sup>{x.sup}</sup>}
                    </p>
                  </div>
                ))}
          </div>

          {descriptionTabPrices && (
            <p className={`descriptionTabPrices`}>
              {descriptionTabPricesSup && <sup>{descriptionTabPricesSup}</sup>}
              {descriptionTabPrices}
              {descriptionTabPricesSupEnd && (
                <sup>{descriptionTabPricesSupEnd}</sup>
              )}
            </p>
          )}
        </div>
        <div></div>
      </div>
    </div>
  );
}
export default CardPrice;
